<template>
  <KisweStudioOverlay
    v-if="showBrowserCheck"
    :isModal="true"
    :isBranded="isBranded"
    :showClose="false"
    :showLanguageSelector="true"
    class="browser-check"
  >
    <template v-slot:header>
      <h1>{{ getTranslation(messageKey) }}</h1>
    </template>
    <template class="browser-check__buttons">
      <KisweButton
        theme="primary"
        @click="openChromeDownload"
      ><KisweIcon name="brands.chrome" />{{ getTranslation('browsercheck_download_chrome') }}</KisweButton>
      <KisweButton
        theme="primary"
        class="browser-check__button--mobile-hidden"
        @click="openEdgeDownload"
      ><KisweIcon name="brands.edge" />{{ getTranslation('browsercheck_download_edge') }}</KisweButton>
      <KisweButton
        theme="primary"
        @click="openSafariDownload"
      ><KisweIcon name="brands.safari" />{{ getTranslation('browsercheck_download_safari') }}</KisweButton>
      <KisweButton
        theme="primary"
        class="browser-check__button--mobile-hidden"
        @click="openFirefoxDownload"
      ><KisweIcon name="brands.firefox" />{{ getTranslation('browsercheck_download_firefox') }}</KisweButton>
    </template>
  </KisweStudioOverlay>
</template>

<script lang="ts" setup>
import './BrowserCheck.scss'
import { computed, watch } from 'vue'
import { isMobile } from 'mobile-device-detect'
import { KisweButton, KisweIcon } from 'kiswe-ui'
import useTranslations from '@/compositions/translations'
import { useTeamBranding } from '@/modules/teams/compositions'
import store from '@/store'
import { KisweStudioOverlay } from '@/modules/ui/components'
import { useRoute } from 'vue-router'
import { isArray } from 'lodash'

const openChromeDownload = () => window.open('https://www.google.com/intl/en_uk/chrome/', '_blank')
const openEdgeDownload = () => window.open('https://www.microsoft.com/en-us/edge', '_blank')
const openFirefoxDownload = () => window.open('https://www.mozilla.org/en-US/firefox/new/', '_blank')
const openSafariDownload = () => window.open('https://support.apple.com/downloads/safari', '_blank')

const { isBranded, isBrandingLoaded } = useTeamBranding()
const { getTranslation } = useTranslations()
const route = useRoute()

const messageKey = computed(() => {
  return isMobile ? 'browsercheck_supportmobilebrowser_text' : 'browsercheck_supportbrowser_text'
})
const showBrowserCheck = computed(() => {
  return isBranded.value || isBrandingLoaded.value
})
const pointerId = computed(() => {
  return isArray(route.params.pointerId) ? route.params.pointerId[0] : route.params.pointerId
})

watch(pointerId, async (newPointerId) => {
  if (newPointerId) {
    await store.dispatch.team.getTeamBrandingByPointerId(newPointerId)
  }
})
</script>
